import type React from "react";
import { CustomCheckbox } from "~/components/ui/check_Box";
import styles from "../../index.module.scss";
import type { TextFieldComponentProps } from "../../types";

const MultiLineTextOptions: React.FC<TextFieldComponentProps> = ({
  options,
  handleTextOptionChange,
  handleBooleanOptionChange,
  isReadOnly,
}) => {
  // テキスト表示オプション
  const multiLineTextDisplayOptions = [
    { key: "required", label: "必須項目にする" },
    { key: "noLabel", label: "フィールド名を表示しない" },
  ];

  return (
    <>
      <div className={styles["form-group"]}>
        <label>デフォルト値</label>
        <input
          type="text"
          value={options.defaultValue || ""}
          onChange={(e) => handleTextOptionChange("defaultValue", e.target.value)}
          readOnly={isReadOnly}
        />
      </div>

      {/* チェックボックスオプション */}
      {multiLineTextDisplayOptions.map((option) => (
        <div key={option.key} className={styles["form-group"]}>
          <CustomCheckbox
            label={option.label}
            checked={options[option.key] || false}
            onChange={(value) => handleBooleanOptionChange(option.key, value)}
            {...(isReadOnly !== undefined && { disabled: isReadOnly })}
          />
        </div>
      ))}
    </>
  );
};

export default MultiLineTextOptions;
